import { APP_BASE_HREF, DatePipe } from '@angular/common';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule } from '@angular/core';
import { HttpClientModule } from '@angular/common/http';
import { MAT_DIALOG_DEFAULT_OPTIONS } from '@angular/material';

import { AppRoutingModule } from './app-routing.module';
import { DashboardModule } from './modules/dashboard.module';
import { HeaderModule } from './modules/header.module';
import { LoginModule } from './modules/login.module';

import { AppComponent } from './app.component';

import { CognitoUtil } from './service/aws/cognito.service';
import { AwsUtil } from './service/aws/aws.service';
import { UserRegistrationService } from './service/aws/user.registration.service';
import { UserLoginService } from './service/aws/user.login.service';
import { UserParametersService } from './service/aws/user.parameters.service';
import { CookieService } from 'ngx-cookie-service';
import { StaffActivityService } from './service/staffactivity.service';
import { EmployeeDataService } from './service/employeedata.service';
import { ResetModule } from './modules/reset.module';

const declarations = [
  AppComponent,
];

const entrycomponents = [
];

const imports = [
  BrowserModule,
  BrowserAnimationsModule,
  HttpClientModule,
  AppRoutingModule,
  DashboardModule,
  HeaderModule,
  LoginModule,
  ResetModule,
];

const providers = [
  { provide: APP_BASE_HREF, useValue: '/' },
  { provide: MAT_DIALOG_DEFAULT_OPTIONS, useValue: { hasBackdrop: false } },
  CognitoUtil,
  AwsUtil,
  UserRegistrationService,
  UserLoginService,
  UserParametersService,
  CookieService,
  DatePipe,
  StaffActivityService,
  EmployeeDataService
];

const bootstrap = [
  AppComponent
];

@NgModule({
  declarations: [
    ...declarations,
  ],
  entryComponents: [
    ...entrycomponents,
  ],
  imports: [
    ...imports
  ],
  providers: [
    ...providers
  ],
  bootstrap: [
    ...bootstrap
  ]
})
export class AppModule {
}
